import { feedbackcard } from '@yes.technology/react-toolkit'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18n-lite'
import { ReCaptchaContext } from 'shared/components/ReCaptchaProvider/ReCaptchaProvider'

const useRecaptcha = () => {
  const { t } = useTranslation()
  const [captcha, setCaptcha] = useState<string>('')

  const { disabled } = useContext(ReCaptchaContext)

  const { executeRecaptcha } = useGoogleReCaptcha()

  const handleReCaptchaVerify = useCallback(async () => {
    if (disabled) return
    if (!executeRecaptcha) return
    executeRecaptcha()
      .then(setCaptcha)
      .catch(() =>
        feedbackcard(t('general-feedback.error.title'), {
          message: t('general-feedback.error.msg'),
          type: 'error'
        })
      )
  }, [executeRecaptcha, t, disabled])

  useEffect(() => {
    handleReCaptchaVerify()
  }, [handleReCaptchaVerify])

  return {
    captcha,
    isCaptchaDisabled: disabled
  }
}

export default useRecaptcha
